<ng-container #content class="childCount()"></ng-container>
